// Intl.DisplayNames is natively supported by every browser Universkin targets
// (Chrome 81+, Safari 14.1+, Firefox 86+). This module used to lazy-load a polyfill from
// polyfill.io, but that domain was hijacked in a 2024 supply-chain attack and is now a dead,
// sinkholed host — loading it triggered a browser "Sign in to polyfill.io" auth popup and, during
// the attack window, was a malware vector. We no longer load any third-party polyfill here.
//
// Kept as an intentional no-op so the existing `import` side-effect in the apps stays valid.
// Do NOT re-introduce an external CDN <script> for this. If support for a pre-2021 browser is ever
// required, bundle the polyfill via npm instead.
const setupDisplayNamesPolyfill = () => {
  // no-op — native Intl.DisplayNames is used when present; nothing is loaded from a CDN.
};

setupDisplayNamesPolyfill();
